/**
 * MIPS analog of APP Plus's NoAcoState (AcoHeader.tsx): shown by the MIPS
 * nav pages when auth has resolved and no practice is selected. Rendered
 * synchronously (no loading flash) — same rule as the APP Plus empty state.
 */
export function NoPracticeState() {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <h2 className="text-xl font-semibold">No practice selected</h2>
      <p className="mt-2 text-muted-foreground">
        Choose a client and practice from the Home page (or the practice
        selector in the top bar) to start MIPS reporting.
      </p>
    </div>
  );
}
